import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="calc-footer">
      {/* Disclaimer Section */}
      <div className="footer-disclaimer">
        <div className="disclaimer-content">
          <h4>⚠️ Disclaimer</h4>
          <p>
            This calculator provides approximate results for educational purposes.
            Actual investment outcomes may vary.
          </p>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-section">
            <h4>About Us</h4>
            <p>
              Providing accurate and easy-to-use financial calculators to help you
              make informed decisions.
            </p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/calculators">All Calculators</a></li>
              <li><a href="/guides">Financial Guides</a></li>
              <li><a href="/blog">Blog</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Popular Calculators</h4>
            <ul>
              <li><a href="/irr">IRR Calculator</a></li>
              <li><a href="/npv">NPV Calculator</a></li>
              <li><a href="/roi">ROI Calculator</a></li>
              <li><a href="/emi">EMI Calculator</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: info@Elexyt.com</p>
            <p>Phone: 080 4169 2763</p>
            <p>Address: Bangalore, India</p>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>&copy; 2025 Elexyt Technologies Pvt. Ltd.. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;